import {UpIcon} from "../../../assets/svg/upIcon";
import {StyledIconButton} from "./BoardButtonUp.styled";

interface UiBoardButtonUpProps {
  aboutFunction: () => void
}

export function UiBoardButtonUp({aboutFunction}: UiBoardButtonUpProps) {
  return (
    <StyledIconButton onClick={aboutFunction}><UpIcon/></StyledIconButton>
  )
}